import {
  faFacebookF,
  faInstagram,
  faTiktok,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { useMediaQuery } from "@mui/material";
import { useIsClient } from "@uidotdev/usehooks";
import { useState } from "react";
import {
  FacebookEmbed,
  InstagramEmbed,
  TikTokEmbed,
  XEmbed,
} from "react-social-media-embed";
import { FlexContainer, TextStyled } from "../styles";
import {
  ArrowContainer,
  ArrowIcon,
  CardContainer,
  CardStyled,
  DialogStyled,
  FontAwesomeIconStyled,
  PlayIconStyled,
  SkeletonContainer,
  SocialMediaWrapper,
} from "./styles";

function CompanySocialMedia(props) {
  const { companyDetail } = props || {};

  const isClient = useIsClient();
  const isMobile = useMediaQuery("(max-width: 640px)");

  return isClient ? (
    <SocialMediaWrapper>
      <ArrowContainer $more={companyDetail?.length > 2}>
        <TextStyled
          fontSize={
            isMobile ? (companyDetail?.length > 2 ? "1rem" : "1.25rem") : "1rem"
          }
          lineHeight={"1.25rem"}
          letterSpacing={"0.15px"}
          fontStyle={"italic"}
        >
          click me!
        </TextStyled>
        <ArrowIcon $more={companyDetail?.length > 2} />
      </ArrowContainer>
      <CardContainer
        justifyContent={companyDetail?.length > 2 ? "flex-start" : "flex-end"}
      >
        {companyDetail?.map((socialMedia, index) => (
          <SocialMediaCard socialMedia={socialMedia} key={index} />
        ))}
      </CardContainer>
    </SocialMediaWrapper>
  ) : (
    <SkeletonContainer />
  );
}

function SocialMediaCard(props) {
  const { socialMedia } = props;

  const [open, setOpen] = useState(false);

  function handleOpen() {
    setOpen(!open);
  }

  const link = socialMedia.socialMediaLink;

  function getSocialMediaType() {
    if (link.includes("facebook.com") || link.includes("fb.com")) {
      return "Facebook";
    } else if (link.includes("twitter.com") || link.includes("x.com")) {
      return "Twitter";
    } else if (link.includes("instagram.com")) {
      return "Instagram";
    } else if (link.includes("tiktok.com")) {
      return "Tiktok";
    }
  }

  const socialMediaType = getSocialMediaType();

  function getSocialMediaIcon() {
    switch (socialMediaType) {
      case "Facebook":
        return <FontAwesomeIconStyled icon={faFacebookF} />;
      case "Twitter":
        return <FontAwesomeIconStyled icon={faXTwitter} />;
      case "Instagram":
        return <FontAwesomeIconStyled icon={faInstagram} />;
      case "Tiktok":
        return <FontAwesomeIconStyled icon={faTiktok} />;
      default:
        return;
    }
  }

  function getColorStyle() {
    switch (socialMediaType) {
      case "Facebook":
        return {
          backgroundColor: "#1877F2",
        };
      case "Twitter":
        return {
          backgroundColor: "#222",
        };
      case "Instagram":
        return {
          background:
            "linear-gradient(45deg, #FFC107 14.63%, #F44336 50.5%, #9C27B0 84.66%)",
        };
      case "Tiktok":
        return {
          backgroundColor: "#222",
        };
      default:
        return;
    }
  }

  return (
    <>
      <CardStyled sx={getColorStyle} onClick={handleOpen}>
        {getSocialMediaIcon()}
        <FlexContainer
          flexDirection={"column"}
          alignItems="center"
          justifyContent="center"
          height="100%"
        >
          <PlayIconStyled />
        </FlexContainer>
      </CardStyled>
      <DialogStyled open={open} onClose={handleOpen}>
        <SocialMediaEmbed url={link} type={socialMediaType} />
      </DialogStyled>
    </>
  );
}

function SocialMediaEmbed(props) {
  const { url, type } = props;

  if (type === "Facebook") {
    return <FacebookEmbed url={url} width={"400px"} />;
  }

  if (type === "Twitter") {
    return <XEmbed url={url} width={"auto"} />;
  }

  if (type === "Instagram") {
    return <InstagramEmbed url={url} width={"auto"} />;
  }

  if (type === "Tiktok") {
    return <TikTokEmbed url={url} width={"auto"} />;
  }

  return null;
}
export default CompanySocialMedia;
